/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/ban-types */
import { ALERT_STATUSES } from '../../components/ContactInfo/constants';
import { logger } from '../../logger';

export const stateAndZipCodeValidator = async (
  zipCode: string,
  state: string,
  countryCode: string,
  languageCode: string
) => {
  return new Promise((resolve, reject) => {
    const geoCoder = new window.google.maps.Geocoder();
    geoCoder.geocode(
      {
        address: zipCode,
        componentRestrictions: { country: countryCode },
        language: languageCode,
      },
      (results: any, status: string) => {
        if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
          // Check if zipcode is available in address_components and state matches
          const addressComponents = results[0]['address_components'];
          const hasZipcode = addressComponents.some(
            (item: any) => item.short_name.toLowerCase() === zipCode.toLowerCase()
          );
          const place = hasZipcode
            ? addressComponents.find(
                (item: any) => item.long_name.toLowerCase() === state.toLowerCase()
              )
            : undefined;

          resolve(place);
        } else {
          reject(false);
        }
      }
    );
  });
};

export const getStateFromZipcode = async (zipCode: string) => {
  return new Promise((reslove, reject) => {
    const geoCoder = new window.google.maps.Geocoder();
    geoCoder.geocode({ address: zipCode }, (results: any, status: string) => {
      if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
        const place = results[0]['address_components'].find((item: any) =>
          item.types.includes('administrative_area_level_1')
        );
        reslove(place?.long_name);
      } else {
        reject(false);
      }
    });
  });
};

export const validateAddresWithZipcode = async (
  address: string,
  zipcode: string,
  zipcodeType: string
) => {
  return new Promise((resolve, reject) => {
    const geoCoder = new window.google.maps.Geocoder();
    geoCoder.geocode({ address: address }, (results: any, status: string) => {
      if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
        const place = results[0]['address_components'].find((item: any) =>
          item.types.includes(zipcodeType)
        );
        let isValid = false;
        if (place?.long_name === zipcode) {
          isValid = true;
        }
        resolve(isValid);
      } else {
        reject(false);
      }
    });
  });
};

export const geocodeFullAddress = async (
  address: string,
  city: string,
  state: string,
  zipcode: string,
  countryCode: string,
  language: string,
  stateTypeConfig?: any[]
): Promise<{ lat: number; lng: number } | null> => {
  const normalizedAddress = (address ?? '').trim();
  const normalizedCity = (city ?? '').trim();
  const normalizedState = (state ?? '').trim();
  const normalizedZipcode = (zipcode ?? '').trim();
  const normalizedCountry = (countryCode ?? '').trim().toLowerCase();
  const normalizedLanguage = (language ?? '').trim().toLowerCase();
  const fullAddress = `${normalizedAddress}+ ${normalizedCity}+ ${normalizedState}+ ${normalizedZipcode}`;
  const stateLower = normalizedState.toLowerCase();

  try {
    const geoCoder = new window.google.maps.Geocoder();

    return await new Promise((resolve, reject) => {
      geoCoder.geocode(
        {
          address: fullAddress,
          componentRestrictions: {
            country: normalizedCountry,
          },
          language: normalizedLanguage,
        },
        (results: google.maps.GeocoderResult[] | null, status: google.maps.GeocoderStatus) => {
          try {
            if (status !== google.maps.GeocoderStatus.OK || !results?.length) {
              logger.warn('geocodeFullAddress failed: with no results', {
                fullAddress,
              });
              resolve(null);
              return;
            }

            let selectedResult = results[0];
            if (results.length > 1) {
              const matchingResult = results.find((result) => {
                const stateComponent = result.address_components.find((component) =>
                  (stateTypeConfig || []).some((stateType: any) =>
                    component.types.includes(stateType.fields.name.value)
                  )
                );
                return stateComponent?.long_name.toLowerCase() === stateLower;
              });
              if (!matchingResult) {
                resolve(null);
                return;
              }
              selectedResult = matchingResult;
            }

            const location = selectedResult.geometry.location;

            resolve({
              lat: location.lat(),
              lng: location.lng(),
            });
          } catch (error) {
            reject(error);
          }
        }
      );
    });
  } catch (error) {
    logger.warn('geocodeFullAddress failed exception', {
      fullAddress,
      error,
    });
    return null;
  }
};

export const validateAddresWithState = async (
  address: string,
  state: string,
  stateTypeConfig: any[]
) => {
  return new Promise((resolve, reject) => {
    const geoCoder = new window.google.maps.Geocoder();
    geoCoder.geocode({ address: address }, (results: any, status: string) => {
      if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
        let statePopulated = false;
        let place: any = '';

        stateTypeConfig.map((stateType: any) => {
          if (statePopulated) {
            return;
          } else {
            results[0]['address_components'].map((item: any) => {
              if (item.types.includes(stateType.fields.name.value)) {
                place = item.long_name;
                statePopulated = true;
                return;
              }
            });
          }
        });

        let isValid = false;

        if (place === state) {
          isValid = true;
        }
        resolve(isValid);
      } else {
        reject(false);
      }
    });
  });
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getAlertStatusIcon = (status: string) => {
  return ALERT_STATUSES[status.toLowerCase()]?.icon;
};

/** Unicode property escapes (e.g. \\p{L}) require the `u` flag in JavaScript RegExp. */
export const regExpFromSitecorePattern = (pattern: string): RegExp => {
  if (pattern.includes('\\p{')) {
    return new RegExp(pattern, 'u');
  }
  return new RegExp(pattern);
};
